module.exports = __webpack_public_path__ + "media/如果可以在夢裡見到你.3285ba42.mp3";